import { render, staticRenderFns } from "./couponDialog.vue?vue&type=template&id=2284fbc2&scoped=true"
import script from "./couponDialog.vue?vue&type=script&lang=js"
export * from "./couponDialog.vue?vue&type=script&lang=js"
import style0 from "./couponDialog.vue?vue&type=style&index=0&id=2284fbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284fbc2",
  null
  
)

export default component.exports